import React from 'react';
import BlankLayoutWithSidebar from '@/layouts/BlankLayoutWithSidebar';

/**
 * This is the layout used for UserProfile page only.
 */
const UserProfileLayout = ({ children }: { children?: React.ReactNode }) => {
  return <BlankLayoutWithSidebar>{children}</BlankLayoutWithSidebar>;
};

export default UserProfileLayout;
